function GameIntroHeader({ title, description }) {
  return (
    <div className="game-introContainer">
      <div className="game-title">{title}</div>
      <div className="game-introText">{description}</div>
    </div>
  );
}

export { GameIntroHeader };
